import { render, staticRenderFns } from "./ShopifyLink.vue?vue&type=template&id=3148e832"
import script from "./ShopifyLink.vue?vue&type=script&lang=js"
export * from "./ShopifyLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports